import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import { NutritionLabel } from "@/components/NutritionLabel";
import type { NutritionSummary } from "@/components/NutritionLabel";

interface RecipeNutritionSectionProps {
  recipeId: number;
  nutritionSummary: NutritionSummary;
  scale?: number;
}

export function RecipeNutritionSection({
  recipeId,
  nutritionSummary,
  scale = 1,
}: RecipeNutritionSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasExpanded, setHasExpanded] = useState(false);

  function handleToggle() {
    if (!hasExpanded) {
      setHasExpanded(true);
    }
    setIsExpanded((v) => !v);
  }

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={handleToggle}
        className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-semibold text-foreground hover:brightness-95 transition-all select-none"
        style={{ background: "#f3f0eb" }}
        aria-expanded={isExpanded}
      >
        <span className="flex items-center gap-2">
          {isExpanded ? (
            <ChevronDown className="w-4 h-4 text-muted-foreground flex-shrink-0" />
          ) : (
            <ChevronRight className="w-4 h-4 text-muted-foreground flex-shrink-0" />
          )}
          Nutrition Facts
        </span>

        <span className="text-xs font-normal text-muted-foreground">
          {Math.round(nutritionSummary.calories)} cal
          &nbsp;·&nbsp;{Math.round(nutritionSummary.protein_g)}g protein
          &nbsp;·&nbsp;{Math.round(nutritionSummary.total_carbs_g)}g carbs
          &nbsp;·&nbsp;{Math.round(nutritionSummary.total_fat_g)}g fat
          <span className="ml-1">per serving</span>
        </span>
      </button>

      <div
        style={{
          maxHeight: isExpanded ? "3000px" : "0px",
          overflow: "hidden",
          transition: "max-height 250ms ease",
        }}
      >
        <div className="pt-2 pb-1 px-1">
          {hasExpanded && (
            <NutritionLabel
              recipeId={recipeId}
              scale={scale}
              showDailyValues
              hideToggle
              defaultExpanded
            />
          )}
        </div>
      </div>
    </div>
  );
}
